import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "search-global-container --with-legend"
  }, [_c("div", {
    staticClass: "search-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Search for a label, producer ...",
      solo: "",
      "append-icon": "fa-search",
      loading: _vm.loadingSearch,
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        !!_vm.searchCriterias.label && _vm.advancedSearch();
      },
      "click:append": _vm.advancedSearch,
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.advancedSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfCellarWines
    }
  })], 1)])]), _c("div", {
    staticClass: "search-legend"
  }, [_c("div", {
    staticClass: "search-legend__main-content"
  }, [_c("div", {
    staticClass: "search-legend-items"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c(VIcon, {
    staticClass: "icon-decrease",
    attrs: {
      color: "black"
    }
  }, [_vm._v("fa-exclamation-triangle")])], 1), _c("div", [_vm._v("The wine quality has passed it's peak, and is decreasing.")])])])]), _c("div", {
    staticClass: "search-legend-closed-label",
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("Legend")]), _c("div", {
    staticClass: "search-legend-closer"
  }, [_c(VIcon, {
    attrs: {
      title: "Close legend"
    },
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("fa-times")])], 1), _c("div", {
    staticClass: "search-legend-opener"
  }, [_c(VIcon, {
    attrs: {
      title: "See legend"
    },
    on: {
      click: function click($event) {
        return _vm.toggleLegend();
      }
    }
  }, [_vm._v("fa-plus")])], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id_cellar_wine",
      "items-per-page": _vm.searchCriterias.paging.limits,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.rowClicked
    },
    scopedSlots: _vm._u([{
      key: "item.image",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "td-img"
        }, [!_vm.imagesBroken.includes(item.id_cellar_wine) && item.imageThumbnail != null && item.imageThumbnail.length > 0 ? _c("img", {
          attrs: {
            src: item.imageThumbnail,
            alt: ""
          },
          on: {
            error: function error($event) {
              return _vm.imagesBroken.push(item.id_cellar_wine);
            }
          }
        }) : !_vm.imagesBroken.includes(item.id_cellar_wine) && item.image != null && item.image.length > 0 ? _c("img", {
          attrs: {
            src: item.image,
            alt: ""
          },
          on: {
            error: function error($event) {
              return _vm.imagesBroken.push(item.id_cellar_wine);
            }
          }
        }) : _vm._e()])];
      }
    }, {
      key: "item.qty",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "qty-field td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", [_c(VTextField, {
          attrs: {
            placeholder: "120",
            "hide-details": "auto"
          },
          on: {
            change: function change($event) {
              return _vm.qtyChanged(item.id_cellar_wine, item.qty);
            }
          },
          model: {
            value: item.qty,
            callback: function callback($$v) {
              _vm.$set(item, "qty", $$v);
            },
            expression: "item.qty"
          }
        }), item.qty < 24 ? _c("div", {
          staticClass: "low-stock",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Low stock")]) : _vm._e()], 1)])];
      }
    }, {
      key: "item.cellar_potential",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [item.cellar_potential == 1 ? _c("div", [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on,
                attrs = _ref4.attrs;
              return [_c("img", _vm._g(_vm._b({
                staticClass: "icon-waiting max-wh-100",
                attrs: {
                  src: require("@/assets/images/icons/wine.svg"),
                  alt: ""
                }
              }, "img", attrs, false), on))];
            }
          }], null, true)
        }, [_c("span", [_vm._v("This wine has yet to attain it's full potential.")])])], 1) : item.cellar_potential == 2 ? _c("div", [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref5) {
              var on = _ref5.on,
                attrs = _ref5.attrs;
              return [_c("img", _vm._g(_vm._b({
                staticClass: "icon-increase max-wh-100",
                attrs: {
                  src: require("@/assets/images/icons/wine.svg"),
                  alt: ""
                }
              }, "img", attrs, false), on))];
            }
          }], null, true)
        }, [_c("span", [_vm._v("This wine quality is good, but still increasing.")])])], 1) : item.cellar_potential == 3 ? _c("div", [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref6) {
              var on = _ref6.on,
                attrs = _ref6.attrs;
              return [_c("img", _vm._g(_vm._b({
                staticClass: "icon-apogee max-wh-100",
                attrs: {
                  src: require("@/assets/images/icons/wine.svg"),
                  alt: ""
                }
              }, "img", attrs, false), on))];
            }
          }], null, true)
        }, [_c("span", [_vm._v("This wine is at its peak.")])])], 1) : item.cellar_potential == 4 ? _c("div", [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                attrs = _ref7.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "icon-decrease",
                attrs: {
                  large: "",
                  color: "black"
                }
              }, "v-icon", attrs, false), on), [_vm._v(" fa-exclamation-triangle ")])];
            }
          }], null, true)
        }, [_c("span", [_vm._v("This wine quality has passed it's peak, and is decreasing.")])])], 1) : _c("div")])];
      }
    }, {
      key: "item.id_wine",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", [_c("div", {
          staticClass: "wine-favorite",
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.toggleFavorite(item.id_wine, item.favorite);
            }
          }
        }, [item.favorite ? _c("i", {
          staticClass: "favorite fas fa-heart",
          attrs: {
            title: "Remove from your favorites"
          }
        }) : _c("i", {
          staticClass: "fas fa-heart",
          attrs: {
            title: "Add to your favorites"
          }
        })]), _vm.$whitelabel.isRatingEnabled ? _c("div", {
          staticClass: "rating-div",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("rating", {
          attrs: {
            idWine: item.id_wine
          }
        })], 1) : _vm._e()])])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfCellarWines
    }
  })], 1)])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("img", {
    staticClass: "icon-waiting",
    attrs: {
      src: require("@/assets/images/icons/wine.svg"),
      alt: ""
    }
  })]), _c("div", [_vm._v("The wine has yet to attain it's full potential.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("img", {
    staticClass: "icon-increase",
    attrs: {
      src: require("@/assets/images/icons/wine.svg"),
      alt: ""
    }
  })]), _c("div", [_vm._v("The wine quality is good, but still increasing.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "search-legend-item"
  }, [_c("div", [_c("img", {
    staticClass: "icon-apogee",
    attrs: {
      src: require("@/assets/images/icons/wine.svg"),
      alt: ""
    }
  })]), _c("div", [_vm._v("The wine is at its peak.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };